import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import React from 'react';
import { styles } from './BundleBuyBanner.css';

export const BundleBuyBanner = () => {
  return (
    <div className={styles.container}>
      <CalloutFont className={styles.text}>BUNDLE BUY!</CalloutFont>

      <svg xmlns="http://www.w3.org/2000/svg" width="90" height="32" viewBox="0 0 90 32" fill="none">
        <path d="M0 0L89 0L89 25.7746L44.0742 30L0 25.7746L0 0Z" fill="#462388" />
        <path
          d="M0.333833 0.333833L88.6662 0.333833L88.6662 25.4707L44.0745 29.6647L0.333833 25.4713L0.333833 0.333833Z"
          stroke="black"
          strokeWidth="1"
        />
      </svg>
    </div>
  );
};
